import React from 'react';
import { Box, useResponsive } from '@common-fe/common-fe';

import { BackButton, Modal } from '@/components';

interface Props {
  title?: string;
  isVisible?: boolean;
  onSetVisible?: (isVisible: boolean) => void;
  children: React.ReactNode;
}
const MobilePageModalWrapper: React.FC<Props> = ({ children, isVisible, onSetVisible, title }) => {
  const { isMobile } = useResponsive();
  const handleToggle = () => {
    if (onSetVisible) {
      onSetVisible(!isVisible);
    }
  };
  if (isMobile) {
    if (!isVisible) {
      return null;
    }
    return (
      <Modal
        isCloseButtonHidden
        isFullScreen
        visible={isVisible}
        contentMobileStyle={{ padding: 0, flex: 1 }}
      >
        <Box pad={{ top: 'spacing24', horizontal: 'spacing12' }} margin={{ left: 'spacing4' }}>
          <BackButton onClick={handleToggle} title={title} />
        </Box>
        <Box
          direction="column"
          style={{ flex: 1 }}
          align="stretch"
          pad={{ horizontal: 'spacing2' }}
          margin={{ top: 'spacing12' }}
        >
          {children}
        </Box>
      </Modal>
    );
  }
  return children;
};

export default MobilePageModalWrapper;
